import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/widget.css';
import { enableAdminDrag } from './lib/admin-drag';

const mount = document.getElementById('grippy-widget-root');
if (!mount) {
  console.warn('[grippy] #grippy-widget-root not found — widget did not mount.');
} else if (!window.grippyWidget) {
  console.warn('[grippy] grippyWidget config not present — widget did not mount.');
} else {
  const theme = window.grippyWidget.theme === 'dark' ? 'dark' : 'light';
  mount.setAttribute('data-theme', theme);
  if (window.grippyWidget.pulse) {
    mount.setAttribute('data-pulse', '1');
  }

  // Position the launcher per admin settings. Defaults to bottom-right
  // with 24px offsets. Side switch toggles a data attribute the CSS
  // reads to flip left/right anchoring.
  const position = window.grippyWidget.position ?? 'bottom-right';
  const offsetBottom = Math.max(0, Math.min(400, Number(window.grippyWidget.offsetBottom ?? 24)));
  const offsetSide = Math.max(0, Math.min(400, Number(window.grippyWidget.offsetSide ?? 24)));
  mount.setAttribute('data-position', position);
  mount.style.setProperty('--g-offset-bottom', `${offsetBottom}px`);
  mount.style.setProperty('--g-offset-side', `${offsetSide}px`);

  // Optional brand-color override from the admin settings.
  const accent = window.grippyWidget.accentColor;
  if (accent && /^#[0-9a-f]{6}$/i.test(accent)) {
    // color-mix(in oklch) gives us a slight tonal shift for the gradient
    // stops without needing a color library client-side.
    mount.style.setProperty('--g-brand-from', `color-mix(in oklch, ${accent} 88%, white)`);
    mount.style.setProperty('--g-brand-to',   accent);
    mount.style.setProperty('--g-brand-mid',  accent);
    mount.style.setProperty('--g-brand-deep', `color-mix(in oklch, ${accent} 80%, black)`);
  }

  createRoot(mount).render(<App />);

  // Start the collision watcher after React has had a tick to mount the
  // launcher into the DOM. Continuously lifts the launcher above any
  // other fixed/sticky element parked in the bottom-right corner
  // (scroll-to-top buttons, cookie banners, WhatsApp widgets, etc.)
  // so clicks on those buttons don't get blocked.
  // Collision watcher removed: it was overshifting the launcher every
  // time any large fixed element appeared (Elementor preview toolbar,
  // debugger, the Claude in Chrome glow overlay). Placement is now
  // purely admin-driven via the offsets in Settings → Widget.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (window.grippyWidget.adminMode && window.grippyWidget.adminNonce) {
        enableAdminDrag({
          apiRoot: window.grippyWidget.apiRoot,
          nonce: window.grippyWidget.adminNonce,
        });
      }
    });
  });
}
